import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/product-list-assets/switches/utility/flex-mini.jpg";
import v3Image from "../../assets/Switching/flexMini.jpg";
import type { Product } from "../../types";
import { productListSwitchingCompact } from "../product-list-groups/productListSwitchingCompact";
import {
  downlinkSpeed,
  etherlighting,
  mounting,
  outdoorReady,
  poeAvailability,
  poeOutput,
  portCount,
  ports,
  powerMethod,
  proAvSupport,
  switchTechnology,
  uplinkSpeed,
} from "../properties";

export const flexMini: Product = {
  id: "flexMini",
  productTitle: "Flex Mini",
  techspecsPath: [SiteId.TechSpecs, "/unifi/switching/usw-flex-mini"],
  storePathParts: {
    productSlug: "usw-flex-mini",
    category: "switching-utility",
  },
  sku: "USW-Flex-Mini",
  description: "flexMini.description",
  descriptionMaxWidth: 170,
  image: { src: image, width: 200, height: 140 },
  v3Image: {
    src: v3Image,
    width: 230,
    height: 120,
  },
  productListGroup: productListSwitchingCompact,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '107 x 70 x 21 mm\n(4.2 x 2.8 x 0.8")',
      },
    },
    {
      propertyId: switchTechnology.id,
      value: {
        type: "translation",
        value: "commons.switchingTechnology.layer2",
      },
    },
    {
      propertyId: portCount.id,
      value: { type: "string", value: "5" },
    },
    {
      propertyId: ports.id,
      value: { type: "string", value: "(5) GbE RJ45" },
    },
    {
      propertyId: downlinkSpeed.id,
      value: { type: "string", value: "1 Gbps" },
    },
    {
      propertyId: uplinkSpeed.id,
      value: { type: "string", value: "1 Gbps" },
    },
    {
      propertyId: poeOutput.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: poeAvailability.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: proAvSupport.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: etherlighting.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "generalRedundancy",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: powerMethod.id,
      value: {
        type: "translation",
        value: "flexMini.powerMethod",
      },
    },
    {
      propertyId: mounting.id,
      value: {
        type: "translation",
        value: "commons.mounting.desktop",
      },
    },
    {
      propertyId: outdoorReady.id,
      value: { type: "boolean", value: false },
    },
  ],
};
